<script setup>
import { onMounted, computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import { useCaptain } from 'dashboard/composables/useCaptain';
import { useRouter } from 'vue-router';

import Banner from 'dashboard/components-next/banner/Banner.vue';

const router = useRouter();
const { accountId } = useAccount();

const { faqLimits, fetchLimits } = useCaptain();

const openBilling = () => {
  router.push({
    name: 'billing_settings_index',
    params: { accountId: accountId.value },
  });
};

const showBanner = computed(() => {
  if (!faqLimits.value) return false;

  const { consumed, totalCount, currentAvailable } = faqLimits.value;
  if (totalCount == null) return false;
  if (currentAvailable === 0) return true;
  if (!totalCount) return false;

  return consumed / totalCount > 0.8;
});

const bannerMessageKey = computed(() => {
  if (faqLimits.value?.currentAvailable === 0) return 'CAPTAIN.BANNER.FAQS';
  return 'CAPTAIN.BANNER.FAQS_WARNING';
});

onMounted(fetchLimits);
</script>

<template>
  <Banner
    v-show="showBanner"
    color="amber"
    :action-label="$t('CAPTAIN.PAYWALL.UPGRADE_NOW')"
    @action="openBilling"
  >
    {{ $t(bannerMessageKey) }}
  </Banner>
</template>
